
import {
    GET_KATUZE_ACTION_TYPE,
} from '../sagas/katuze';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    katuzeItems: null
};

export function getKatuzeItems(state) {
    return state.katuzeItems
        ? state.katuzeItems
        : [];
}

function processActionResult(state, action) {
    switch (action.data.result.operation) {
        case GET_KATUZE_ACTION_TYPE.DEFAULT:
            return {
                katuzeItems: action.data.result.result
            };
        default:
            return {};
    }
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(GET_KATUZE_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case GET_KATUZE_ACTION_TYPE.SUCCESS:
                return {
                    ...state,
                    ...loaderReducer(state, action),
                    ...processActionResult(state, action)
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
